export const appConfig = {
  globalTenantAlias: 'app',
  baseDomain: process.env.VUE_APP_CLIENT_DOMAIN,
  debugConfig: {
    // NOTE: try to set this as false at the end of the session
    // activateXDebug: false,
    activateXDebug: process.env.VUE_APP_ACTIVATE_XDEBUG && true,
    xdebugSession: 'PHPSTORM',
  },
  modules: {
    activatePosV2: process.env.VUE_APP_POS_V2_ACTIVATED === 'true',
  },

  apiPathV1: process?.env?.VUE_APP_API_PATH || '/api/v1',
  publicApiPathV1: process?.env?.VUE_APP_PUBLIC_API_PATH || '/public-api/v1',
  apiPathV2: process?.env?.VUE_APP_API_PATH_V2 || '/api/v2',
};
